
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 10 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m5 0.5c-0.55228 0-1 0.44772-1 1v3h-3c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1h3v3c0 0.5523 0.44772 1 1 1s1-0.4477 1-1v-3h3c0.55229 0 1-0.44772 1-1s-0.44772-1-1-1h-3v-3c0-0.55228-0.44772-1-1-1z","clip-rule":"evenodd","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    